import { render, staticRenderFns } from "./TariffSettingsButton.vue?vue&type=template&id=42764079&scoped=true&"
import script from "./TariffSettingsButton.vue?vue&type=script&lang=ts&"
export * from "./TariffSettingsButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42764079",
  null
  
)

export default component.exports